module.exports = __webpack_public_path__ + "media/images/pic/teachers/joanna-shimada-c8086fbf13a663abec57c36179e4af8e.webp";